import {connect} from 'react-redux';
import Countries from '../components/Countries';

const mapDispatchToProps = {
};

const mapStateToProps = (state) => ({
  lang: state.locale.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(Countries);
